<template>
  <!-- لطفا اگر میخواهید این کامپوننت را کپی کنید خط شماره ۱۱۰ را تغییر دهید -->
  <span>
    <v-dialog v-model="dialog" fullscreen>
      <template v-slot:activator="{ on }">

        <span  v-on="on" class="ck-file-dialog-button">
          <button class="ck ck-button ck-off" type="button" tabindex="-1" aria-labelledby="ck-editor__aria-label_e5c2e6d334d9a95b3d012e9e84094777b">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 425.977 425.977" style="enable-background:new 0 0 425.977 425.977;" xml:space="preserve">
<g>
	<path d="M217.039,202.323c-21.736,21.738-21.736,57.11,0,78.848c21.74,21.738,57.111,21.738,78.85,0   c21.738-21.738,21.738-57.11,0-78.848C274.151,180.585,238.779,180.585,217.039,202.323z"/>
	<path d="M412.326,331.257l-44.018-44.018l21.42-144.567c1.072-7.238-1.061-14.585-5.84-20.126   c-4.478-5.191-10.869-8.314-17.674-8.686V61.389c0-25.563-20.799-46.36-46.361-46.36h-75.279c-25.051,0-38.35,10.578-48.063,18.303   c-7.807,6.208-12.518,9.956-22.625,9.956H65.1c-22.781,0-41.314,18.062-41.314,40.263v30.311   c-6.807,0.372-13.195,3.495-17.674,8.686c-4.779,5.541-6.912,12.888-5.84,20.125l30.195,203.802   c1.826,12.338,12.416,21.475,24.889,21.475h261.627l29.326,29.326c8.816,8.818,20.539,13.674,33.01,13.674   c12.469,0,24.191-4.856,33.008-13.673C430.528,379.074,430.528,349.459,412.326,331.257z M54.08,113.823V83.55   c0-6.239,5.602-9.967,11.02-9.967h108.787c20.688,0,32.219-9.172,41.484-16.542c8.551-6.802,14.732-11.716,29.203-11.716h75.279   c8.857,0,16.066,7.206,16.066,16.065v52.434H54.08z M394.315,379.598c-8.467,8.468-22.195,8.468-30.662,0l-55.984-55.985   c-4.145-4.145-6.256-9.549-6.344-14.98c-31.293,21.003-74.172,17.693-101.805-9.94c-31.402-31.4-31.402-82.491,0-113.891   c31.398-31.4,82.49-31.4,113.891,0c27.633,27.633,30.943,70.514,9.939,101.806c5.432,0.088,10.836,2.198,14.98,6.342l55.984,55.985   C402.781,357.402,402.781,371.131,394.315,379.598z"/>
</g>

</svg>
            <span class="ck ck-tooltip ck-tooltip_s">
              <span class="ck ck-tooltip__text">مدیریت فایل</span>
            </span>
            <span class="ck ck-button__label" id="ck-editor__aria-label_e5c2e6d334d9a95b3d012e9e84094777b">مدیریت فایل</span>
          </button>
          <input class="ck-hidden" type="file" tabindex="-1" accept="image/jpeg,image/png,image/gif,image/bmp,image/webp,image/tiff" multiple="true"></span>

        
          <!-- <v-icon v-on="on">mdi-folder-search</v-icon> -->
      </template>

      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>مدیریت فایل</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row class="mt-3">
              <v-col
                v-for="item in fileList"
                :key="item.id"
                class="d-flex child-flex"
                cols="4"
                md="2"
              >
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-img
                      :src="item.file.thumbnailFileUrl"
                      :lazy-src="item.file.thumbnailFileUrl"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="transition-fast-in-fast-out primary v-card--reveal white--text"
                          style="height: 100%"
                        >
                          <v-btn
                            block
                            @click="selectImage(item)"
                            class="warning ma-1"
                            >انتخاب</v-btn
                          >
                          <v-btn
                            block
                            v-if="item.contentType == 'image/png'"
                            @click="showImage(item)"
                            class="warning ma-1"
                            >مشاهده</v-btn
                          >
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-card>
                </v-hover>
              </v-col>
              <v-col cols="12">
                <scroll-loader
                  v-if="loadMore"
                  :loader-method="getAllFiles"
                  :loader-enable="loadMore"
                >
                </scroll-loader>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>
<script>
export default {
  name: 'FileManager',
  data() {
    return {
      loadMore: true,
      fileList: [],
      dialog: false,
      pageNumber: 1,
      itemPerPage: 8,
    };
  },
  computed: {
    baseUrl() {
      return this.$store.getters.fileBaseUrl;
    },
  },
  methods: {
    getAllFiles() {
      this.axios
        .get('/api/v1/files/pagedlist/byfoldertype/bysupplier', {
          baseURL: this.baseUrl,
          headers: {
            Authorization:
              'Bearer ' + localStorage.getItem('taksan_supplier_access_token'),
            Folder: 'Public',
          },
          params: {
            PageNumber: this.pageNumber++,
            ItemsPerPage: this.itemPerPage,
          },
        })
        .then((data) => {
          // Stop scroll-loader
          if (data.data.list.length == 0) {
            this.loadMore = false;
            return;
          }
          for (let index = 0; index < data.data.list.length; index++) {
            const element = data.data.list[index];
            this.fileList.push(element);
          }
        })
        .catch((error) => alert(error));
    },
    selectImage(selectedItem) {
      this.$emit('selected', selectedItem);
      this.dialog = false;
    },
    showImage(item) {
      window.open(item.file.fileUrl, '_blank').focus();
    },
  },
  mounted() {
    this.getAllFiles();
    // this.getAllFiles();
  },
};
</script>
<style lang="scss" scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}
</style>
